import axios from "axios";
import { getBackendUrl } from "./backend.url";

export const getRanking = (eventId) => {
  return axios.get(`${getBackendUrl()}/ranking/${eventId}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const createRanking = (eventId) => {
  return axios.post(
    `${getBackendUrl()}/ranking/create/${eventId}`,
    {},
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};

export const updateRanking = (eventId, userId, increase) => {
  return axios.post(
    `${getBackendUrl()}/ranking/update/${eventId}/${userId}/${increase}`,
    {},
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};
